export function getActivityType(tenantType){
    var tenantTypeaName = "";
    switch(tenantType){
        case '1':
            tenantTypeaName = "个人";
        case '2':
            tenantTypeaName = "企业";
        case '3':
            tenantTypeaName = "工作站";
        case '4':
            tenantTypeaName = "版权局";
        case '5':
            tenantTypeaName = "区县版权局";
        case '6':
            tenantTypeaName = "服务站";
        default:
            tenantTypeaName = "工作站";

    }
    return tenantTypeaName;
}